"use client";

import { useEffect, useState } from "react";
import { subscribeNotificationUserStateUpdated } from "./notificationSyncSignal";

const NOTIFICATION_SYNC_STORAGE_KEYS = new Set([
  "notification_latest_seen_v1",
  "notification_read_ids_v1",
  "notification_message_read_map_v1",
  "notification_action_visibility_v1",
]);

export function useNotificationSyncVersion(): number {
  const [version, setVersion] = useState(0);

  useEffect(() => {
    const bumpVersion = () => {
      setVersion((prev) => prev + 1);
    };

    const unsubscribe = subscribeNotificationUserStateUpdated(bumpVersion);

    const handleStorage = (event: StorageEvent) => {
      if (!event.key) {
        bumpVersion();
        return;
      }
      if (NOTIFICATION_SYNC_STORAGE_KEYS.has(event.key)) {
        bumpVersion();
      }
    };

    window.addEventListener("storage", handleStorage);

    return () => {
      unsubscribe();
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  return version;
}
